import { createAsyncThunk } from '@reduxjs/toolkit';
import { SubMateriService } from 'Services/axios/SubMateri.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchSubMaterial = createAsyncThunk(
  'SubMaterial/fetchSubMaterial',
  async (filters) => {
    try {
      const response = await SubMateriService.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitSubMaterial = createAsyncThunk(
  'addSubMaterial/submitSubMaterial',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('type', data.type);
      formData.append('name', data.name);
      formData.append('description', data.description);

      if (data.type === 'ebook' || data.type === 'youtube') {
        data.link && formData.append('link', data.link);
      }
      if (data.type === 'image' || data.type === 'video' || data.type === 'audio') {
        data.file && formData.append('uploaded_file', data.file);
      }
      data.duration && formData.append('duration', data.duration);

      let response;
      if (data.isUpdate) {
        response = await SubMateriService.update(data.id, formData);
      } else {
        response = await SubMateriService.create(formData);
      }

      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteSubMaterial = createAsyncThunk(
  'deleteSubMaterial/deleteSubMaterial',
  async (id) => {
    try {
      const response = await SubMateriService.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachDetachSubMaterial = createAsyncThunk(
  'attachDetachSubMaterial/attachDetachSubMaterial',
  async (data) => {
    try {
      await SubMateriService.attachDetach(
        data.method,
        data.type,
        data.idSubmateri,
        data.idTryout
      );
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const replicateSubMaterial = createAsyncThunk(
  'SubMaterial/replicateSubMaterial',
  async (id) => {
    try {
      const response = await SubMateriService.replicate(id);
      return response;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page > 1) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page - 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
  if (pagination.current_page < pagination.last_page) {
    dispatch(setFilters({
      ...filters,
      page: pagination.current_page + 1
    }));
    setRefetch(prevRefetch => !prevRefetch);
  }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
  dispatch(setFilters({
    ...filters,
    page: page
  }));
  setRefetch(prevRefetch => !prevRefetch);
}